var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "star-rating-display" },
    [
      _vm.row
        ? [
            _c("div", { staticClass: "star-rating-display-inner" }, [
              _c(
                "div",
                {
                  staticClass: "star-rating",
                  attrs: { title: _vm.titleDisplay },
                },
                [
                  _vm._l(_vm.stars, function (star, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "star-container" },
                      [
                        _c("div", { staticClass: "star" }, [
                          _c("div", {
                            staticClass: "star-inner",
                            style: `--star-value: ${star.percent}%`,
                          }),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.isIndicatorActive
                    ? _c("div", { staticClass: "indicator" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.rating) + "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRatingAmount
                    ? _c(
                        "div",
                        {
                          staticClass: "rating",
                          attrs: { title: _vm.pluralDisplay },
                        },
                        [
                          _vm._v(
                            "\n          (" +
                              _vm._s(_vm.ratingAmount) +
                              ")\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        : [
            _c(
              "div",
              { staticClass: "star-rating-display-inner star-column" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.rating))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "star-rating",
                    attrs: { title: _vm.titleDisplay },
                  },
                  [
                    _vm.isIndicatorActive
                      ? _c("div", { staticClass: "indicator" }, [
                          _vm._v(
                            "\n          " + _vm._s(_vm.rating) + "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.stars, function (star, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "star-container" },
                        [
                          _c("div", { staticClass: "star" }, [
                            _c("div", {
                              staticClass: "star-inner",
                              style: `--star-value: ${star.percent}%`,
                            }),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.hasRatingAmount
                  ? _c(
                      "div",
                      {
                        staticClass: "rating",
                        attrs: { title: _vm.pluralDisplay },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.pluralDisplay) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }